import React from 'react'

export default ({ className = null, width = 30, height = 30 }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 30 30">
    <defs>
      <path
        id="drift-widget-download-a"
        d="M22 24H2c-1.103 0-2-.897-2-1.999v-5.998a.999.999 0 1 1 2 0v5.998h20v-5.998a.999.999 0 1 1 2 0v5.998A2.002 2.002 0 0 1 22 24zm-9.292-6.301a.99.99 0 0 1-.326.217.991.991 0 0 1-1.086-.213l-.002-.002-.002-.002-4.998-4.987a1 1 0 0 1 1.412-1.415L11 14.583V.999a.999.999 0 1 1 2 0v13.584l3.294-3.286a1 1 0 0 1 1.412 1.415l-4.998 4.987z"
      />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(3 3)">
      <mask id="drift-widget-download-b" fill="#fff">
        <use xlinkHref="#drift-widget-download-a" />
      </mask>
      <use fill="#000" fillRule="nonzero" xlinkHref="#drift-widget-download-a" />
      <g fill="#353F45" mask="url(#drift-widget-download-b)">
        <path d="M-3-3h30v30H-3z" />
      </g>
    </g>
  </svg>
)
